import React from 'react';
import { Link } from 'react-router-dom';
import { humanize } from './automationFormat';

export default function AutomationProgressDetails({ result = {} }) {
  if (!result || (!result.workflow_id && !result.template_id)) return null;
  return (
    <dl className="mt-2 space-y-1 break-words text-xs">
      {result.phase && <div><dt className="font-medium">Last Launch Phase</dt><dd>{humanize(result.phase)}</dd></div>}
      {result.template_id && (
        <div><dt className="font-medium">Campaign Template</dt>
          <dd>{result.campaign_name} <span className="font-mono">{result.template_id}</span></dd>
        </div>
      )}
      {result.workflow_id && (
        <div><dt className="font-medium">Workflow</dt>
          <dd>{result.workflow_name} <span className="font-mono">{result.workflow_id}</span></dd>
          {result.workflow_status && <dd>Status: {humanize(result.workflow_status)}</dd>}
          <dd><Link to="/app/workflows" className="underline">Review Workflows Before Retrying</Link></dd>
        </div>
      )}
    </dl>
  );
}
